// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VideoUpscaleRouteImport } from './routes/video-upscale'
import { Route as TextToVideoRouteImport } from './routes/text-to-video'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReferenceToVideoRouteImport } from './routes/reference-to-video'
import { Route as RamalamaTrendRouteImport } from './routes/ramalama-trend'
import { Route as PhotoToAnimationRouteImport } from './routes/photo-to-animation'
import { Route as ImageUpscaleRouteImport } from './routes/image-upscale'
import { Route as ImageToVideoRouteImport } from './routes/image-to-video'
import { Route as ImageStitchRouteImport } from './routes/image-stitch'
import { Route as ImageGeneratorRouteImport } from './routes/image-generator'
import { Route as ImageEditorRouteImport } from './routes/image-editor'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as DevilWearsPradaAiRouteImport } from './routes/devil-wears-prada-ai'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CreationRouteImport } from './routes/creation'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AiVideoExtenderRouteImport } from './routes/ai-video-extender'
import { Route as AiVideoEditorRouteImport } from './routes/ai-video-editor'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as VideoIdRouteImport } from './routes/video/$id'
import { Route as PromptIdRouteImport } from './routes/prompt/$id'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as testsTestErrorRouteImport } from './routes/(tests)/test-error'
import { Route as testsTest404RouteImport } from './routes/(tests)/test-404'
import { Route as pagesWaitlistRouteImport } from './routes/(pages)/waitlist'
import { Route as pagesPricingRouteImport } from './routes/(pages)/pricing'
import { Route as pagesContactRouteImport } from './routes/(pages)/contact'
import { Route as pagesChangelogRouteImport } from './routes/(pages)/changelog'
import { Route as pagesAboutRouteImport } from './routes/(pages)/about'
import { Route as legalsTermsRouteImport } from './routes/(legals)/terms'
import { Route as legalsPrivacyRouteImport } from './routes/(legals)/privacy'
import { Route as legalsCookieRouteImport } from './routes/(legals)/cookie'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsSecurityRouteImport } from './routes/settings/security'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsPaymentRouteImport } from './routes/settings/payment'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsFilesRouteImport } from './routes/settings/files'
import { Route as SettingsCreditsRouteImport } from './routes/settings/credits'
import { Route as SettingsBillingRouteImport } from './routes/settings/billing'
import { Route as SettingsApikeysRouteImport } from './routes/settings/apikeys'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CreationIdRouteImport } from './routes/creation/$id'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthErrorRouteImport } from './routes/auth/error'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTasksRouteImport } from './routes/admin/tasks'
import { Route as AdminRedemptionsRouteImport } from './routes/admin/redemptions'
import { Route as AdminPromptsRouteImport } from './routes/admin/prompts'
import { Route as AdminTaskIdRouteImport } from './routes/admin/task.$id'
import { Route as AdminPromptsIdEditRouteImport } from './routes/admin/prompts.$id.edit'

const VideoUpscaleRoute = VideoUpscaleRouteImport.update({
            id: '/video-upscale',path: '/video-upscale',getParentRoute: () => rootRouteImport
          })
const TextToVideoRoute = TextToVideoRouteImport.update({
            id: '/text-to-video',path: '/text-to-video',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const ReferenceToVideoRoute = ReferenceToVideoRouteImport.update({
            id: '/reference-to-video',path: '/reference-to-video',getParentRoute: () => rootRouteImport
          })
const RamalamaTrendRoute = RamalamaTrendRouteImport.update({
            id: '/ramalama-trend',path: '/ramalama-trend',getParentRoute: () => rootRouteImport
          })
const PhotoToAnimationRoute = PhotoToAnimationRouteImport.update({
            id: '/photo-to-animation',path: '/photo-to-animation',getParentRoute: () => rootRouteImport
          })
const ImageUpscaleRoute = ImageUpscaleRouteImport.update({
            id: '/image-upscale',path: '/image-upscale',getParentRoute: () => rootRouteImport
          })
const ImageToVideoRoute = ImageToVideoRouteImport.update({
            id: '/image-to-video',path: '/image-to-video',getParentRoute: () => rootRouteImport
          })
const ImageStitchRoute = ImageStitchRouteImport.update({
            id: '/image-stitch',path: '/image-stitch',getParentRoute: () => rootRouteImport
          })
const ImageGeneratorRoute = ImageGeneratorRouteImport.update({
            id: '/image-generator',path: '/image-generator',getParentRoute: () => rootRouteImport
          })
const ImageEditorRoute = ImageEditorRouteImport.update({
            id: '/image-editor',path: '/image-editor',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const FavoritesRoute = FavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => rootRouteImport
          })
const DevilWearsPradaAiRoute = DevilWearsPradaAiRouteImport.update({
            id: '/devil-wears-prada-ai',path: '/devil-wears-prada-ai',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CreationRoute = CreationRouteImport.update({
            id: '/creation',path: '/creation',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AiVideoExtenderRoute = AiVideoExtenderRouteImport.update({
            id: '/ai-video-extender',path: '/ai-video-extender',getParentRoute: () => rootRouteImport
          })
const AiVideoEditorRoute = AiVideoEditorRouteImport.update({
            id: '/ai-video-editor',path: '/ai-video-editor',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const VideoIdRoute = VideoIdRouteImport.update({
            id: '/video/$id',path: '/video/$id',getParentRoute: () => rootRouteImport
          })
const PromptIdRoute = PromptIdRouteImport.update({
            id: '/prompt/$id',path: '/prompt/$id',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const testsTestErrorRoute = testsTestErrorRouteImport.update({
            id: '/(tests)/test-error',path: '/test-error',getParentRoute: () => rootRouteImport
          })
const testsTest404Route = testsTest404RouteImport.update({
            id: '/(tests)/test-404',path: '/test-404',getParentRoute: () => rootRouteImport
          })
const pagesWaitlistRoute = pagesWaitlistRouteImport.update({
            id: '/(pages)/waitlist',path: '/waitlist',getParentRoute: () => rootRouteImport
          })
const pagesPricingRoute = pagesPricingRouteImport.update({
            id: '/(pages)/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const pagesContactRoute = pagesContactRouteImport.update({
            id: '/(pages)/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const pagesChangelogRoute = pagesChangelogRouteImport.update({
            id: '/(pages)/changelog',path: '/changelog',getParentRoute: () => rootRouteImport
          })
const pagesAboutRoute = pagesAboutRouteImport.update({
            id: '/(pages)/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const legalsTermsRoute = legalsTermsRouteImport.update({
            id: '/(legals)/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const legalsPrivacyRoute = legalsPrivacyRouteImport.update({
            id: '/(legals)/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const legalsCookieRoute = legalsCookieRouteImport.update({
            id: '/(legals)/cookie',path: '/cookie',getParentRoute: () => rootRouteImport
          })
const SettingsIndexRoute = SettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SettingsRoute
          })
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => SettingsRoute
          })
const SettingsProfileRoute = SettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => SettingsRoute
          })
const SettingsPaymentRoute = SettingsPaymentRouteImport.update({
            id: '/payment',path: '/payment',getParentRoute: () => SettingsRoute
          })
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => SettingsRoute
          })
const SettingsFilesRoute = SettingsFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => SettingsRoute
          })
const SettingsCreditsRoute = SettingsCreditsRouteImport.update({
            id: '/credits',path: '/credits',getParentRoute: () => SettingsRoute
          })
const SettingsBillingRoute = SettingsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => SettingsRoute
          })
const SettingsApikeysRoute = SettingsApikeysRouteImport.update({
            id: '/apikeys',path: '/apikeys',getParentRoute: () => SettingsRoute
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const CreationIdRoute = CreationIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => CreationRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthRegisterRoute = AuthRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => AuthRoute
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const AuthErrorRoute = AuthErrorRouteImport.update({
            id: '/error',path: '/error',getParentRoute: () => AuthRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AdminRoute
          })
const AdminTasksRoute = AdminTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AdminRoute
          })
const AdminRedemptionsRoute = AdminRedemptionsRouteImport.update({
            id: '/redemptions',path: '/redemptions',getParentRoute: () => AdminRoute
          })
const AdminPromptsRoute = AdminPromptsRouteImport.update({
            id: '/prompts',path: '/prompts',getParentRoute: () => AdminRoute
          })
const AdminTaskIdRoute = AdminTaskIdRouteImport.update({
            id: '/task/$id',path: '/task/$id',getParentRoute: () => AdminRoute
          })
const AdminPromptsIdEditRoute = AdminPromptsIdEditRouteImport.update({
            id: '/$id/edit',path: '/$id/edit',getParentRoute: () => AdminPromptsRoute
          })





const AdminPromptsRouteChildren = {
  AdminPromptsIdEditRoute: AdminPromptsIdEditRoute
}

const AdminPromptsRouteWithChildren = AdminPromptsRoute._addFileChildren(AdminPromptsRouteChildren)



const AdminRouteChildren = {
  AdminPromptsRoute: AdminPromptsRouteWithChildren,AdminRedemptionsRoute: AdminRedemptionsRoute,AdminTasksRoute: AdminTasksRoute,AdminUsersRoute: AdminUsersRoute,AdminIndexRoute: AdminIndexRoute,AdminTaskIdRoute: AdminTaskIdRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AuthRouteChildren = {
  AuthErrorRoute: AuthErrorRoute,AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthLoginRoute: AuthLoginRoute,AuthRegisterRoute: AuthRegisterRoute,AuthResetPasswordRoute: AuthResetPasswordRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const CreationRouteChildren = {
  CreationIdRoute: CreationIdRoute
}

const CreationRouteWithChildren = CreationRoute._addFileChildren(CreationRouteChildren)




const DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const SettingsRouteChildren = {
  SettingsApikeysRoute: SettingsApikeysRoute,SettingsBillingRoute: SettingsBillingRoute,SettingsCreditsRoute: SettingsCreditsRoute,SettingsFilesRoute: SettingsFilesRoute,SettingsNotificationsRoute: SettingsNotificationsRoute,SettingsPaymentRoute: SettingsPaymentRoute,SettingsProfileRoute: SettingsProfileRoute,SettingsSecurityRoute: SettingsSecurityRoute,SettingsIndexRoute: SettingsIndexRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AiVideoEditorRoute: AiVideoEditorRoute,AiVideoExtenderRoute: AiVideoExtenderRoute,AuthRoute: AuthRouteWithChildren,CreationRoute: CreationRouteWithChildren,DashboardRoute: DashboardRouteWithChildren,DevilWearsPradaAiRoute: DevilWearsPradaAiRoute,FavoritesRoute: FavoritesRoute,HistoryRoute: HistoryRoute,ImageEditorRoute: ImageEditorRoute,ImageGeneratorRoute: ImageGeneratorRoute,ImageStitchRoute: ImageStitchRoute,ImageToVideoRoute: ImageToVideoRoute,ImageUpscaleRoute: ImageUpscaleRoute,PhotoToAnimationRoute: PhotoToAnimationRoute,RamalamaTrendRoute: RamalamaTrendRoute,ReferenceToVideoRoute: ReferenceToVideoRoute,SettingsRoute: SettingsRouteWithChildren,TextToVideoRoute: TextToVideoRoute,VideoUpscaleRoute: VideoUpscaleRoute,legalsCookieRoute: legalsCookieRoute,legalsPrivacyRoute: legalsPrivacyRoute,legalsTermsRoute: legalsTermsRoute,pagesAboutRoute: pagesAboutRoute,pagesChangelogRoute: pagesChangelogRoute,pagesContactRoute: pagesContactRoute,pagesPricingRoute: pagesPricingRoute,pagesWaitlistRoute: pagesWaitlistRoute,testsTest404Route: testsTest404Route,testsTestErrorRoute: testsTestErrorRoute,BlogSlugRoute: BlogSlugRoute,PromptIdRoute: PromptIdRoute,VideoIdRoute: VideoIdRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)